import React, { useContext, useEffect } from "react";
import { UserContext } from "../../../../../../context/UserContext";
import { options } from "../util";
import { Stack, Typography } from "@mui/material";
import { Field } from "formik";
import { FormContainer, NavButtons } from "../../../../Menu/Flow";
import employerFlowStyles from "../../styles";
import { styles } from "../../../../../../legacyComponents/componentsV2/FlowV2/Fields/util";

export default function Organization(props) {
  const { mode, exitUrl, step, formik } = props;
  const { errors, touched } = formik;
  const { getEmployer } = useContext(UserContext);
  const employer = getEmployer();

  const registrationTypes = options.registrationTypes;
  const registrationLabels = Object.values(registrationTypes);

  /**
   * Records saved since last October hold the numeric key instead of the
   * label. Convert it here so the select shows the right choice, and the
   * next save writes the string.
   */
  useEffect(() => {
    const current = formik.values.registrationType;
    if (current === null || current === undefined || current === "") return;
    if (registrationLabels.includes(current)) return;
    const label = registrationTypes[current];
    if (label) {
      formik.setFieldValue("registrationType", label);
    }
  }, [formik.values.registrationType]);

  return (
    <Stack spacing="30px" height="100%">
      <FormContainer>
        <Typography variant="h2" sx={employerFlowStyles.h2}>
          Organization
        </Typography>
        <Typography>Tell us about your company.</Typography>

        <Stack spacing={2} sx={{ marginTop: "40px" }}>
          {/* Company EIN */}
          <Stack>
            <Typography sx={{ marginBottom: "8px" }}>Company EIN</Typography>
            <Field name="ein">
              {({ field, form }) => (
                <input
                  {...field}
                  onChange={(e) => {
                    const value = e.target.value.replace(/-/g, "");
                    form.setFieldValue("ein", value);
                  }}
                  type="text"
                  placeholder="Enter Company EIN"
                  maxLength="10"
                  style={{
                    width: "100%",
                    padding: "12px",
                    border: `1px solid ${errors.ein && touched.ein ? "#dc2626" : "#ACBEE8"}`,
                    borderRadius: "8px",
                    fontSize: "14px",
                  }}
                />
              )}
            </Field>
            {errors.ein && touched.ein && (
              <div className="error-message-fields">{errors.ein}</div>
            )}
          </Stack>

          {/* Ownership Type */}
          <Stack>
            <Typography sx={{ marginTop: "20px", marginBottom: "8px" }}>
              Ownership Type
            </Typography>
            <Field name="registrationType">
              {({ field }) => (
                <select
                  {...field}
                  style={{
                    ...styles.select(!field.value),
                    border: `1px solid ${errors.registrationType && touched.registrationType ? "#dc2626" : "#ACBEE8"}`,
                  }}
                >
                  <option value="">Select Ownership Type</option>
                  {Object.entries(options.registrationTypes).map(
                    ([value, label]) => (
                      <option key={value} value={label}>
                        {label}
                      </option>
                    ),
                  )}
                </select>
              )}
            </Field>
            {errors.registrationType && touched.registrationType && (
              <div className="error-message-fields">
                {errors.registrationType}
              </div>
            )}
          </Stack>

          {/* State of Registration */}
          <Stack>
            <Typography sx={{ marginTop: "20px", marginBottom: "8px" }}>
              State Of Registration
            </Typography>
            <Field name="registrationState">
              {({ field }) => (
                <select
                  {...field}
                  style={{
                    ...styles.select(!field.value),
                    border: `1px solid ${errors.registrationState && touched.registrationState ? "#dc2626" : "#ACBEE8"}`,
                  }}
                >
                  <option value="">Select State</option>
                  {Object.entries(options.stateArray).map(([key, value]) => (
                    <option key={key} value={key}>
                      {value}
                    </option>
                  ))}
                </select>
              )}
            </Field>
            {errors.registrationState && touched.registrationState && (
              <div className="error-message-fields">
                {errors.registrationState}
              </div>
            )}
          </Stack>

          {/* Display Name */}
          <Stack>
            <Typography sx={{ marginTop: "20px", marginBottom: "8px" }}>
              Display Name
            </Typography>
            <Field name="displayName">
              {({ field, form }) => (
                <input
                  {...field}
                  onBlur={(e) => {
                    const trimmedValue = e.target.value.trim();
                    if (trimmedValue === "") {
                      form.setFieldValue("displayName", employer?.name || "");
                    } else {
                      form.setFieldValue("displayName", trimmedValue);
                    }
                    form.setFieldTouched("displayName", true);
                  }}
                  type="text"
                  placeholder="Enter Display Name"
                  style={{
                    width: "100%",
                    padding: "12px",
                    border: `1px solid ${errors.displayName && touched.displayName ? "#dc2626" : "#ACBEE8"}`,
                    borderRadius: "8px",
                    fontSize: "14px",
                  }}
                />
              )}
            </Field>
            {errors.displayName && touched.displayName && (
              <div className="error-message-fields">{errors.displayName}</div>
            )}
          </Stack>

          {/* Website */}
          <Stack>
            <Typography sx={{ marginTop: "20px", marginBottom: "8px" }}>
              Website
            </Typography>
            <Field name="website">
              {({ field }) => (
                <input
                  {...field}
                  type="text"
                  placeholder="Enter Website"
                  style={{
                    width: "100%",
                    padding: "12px",
                    border: `1px solid ${errors.website && touched.website ? "#dc2626" : "#ACBEE8"}`,
                    borderRadius: "8px",
                    fontSize: "14px",
                  }}
                />
              )}
            </Field>
            {errors.website && touched.website && (
              <div className="error-message-fields">{errors.website}</div>
            )}
          </Stack>
        </Stack>
      </FormContainer>

      <NavButtons mode={mode} enableSave={true} exitUrl={exitUrl} step={step} />
    </Stack>
  );
}
